import { render } from "./TelemedicineContentEs.vue?vue&type=template&id=2af12975"
import script from "./TelemedicineContentEs.vue?vue&type=script&lang=js"
export * from "./TelemedicineContentEs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__